var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconNotificationsOff = function SvgIconNotificationsOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.414 1.414 16.264 16.264-1.415 1.414L16.172 17h-4.443A2 2 0 0 1 12 18a2 2 0 1 1-3.812-.845L8.27 17H2v-1l2-2V8c0-.927.21-1.804.586-2.587L2 2.828l1.414-1.414Zm2.593 6.351L6 8v6.828L5.828 15h8.344L14 14.828 6.136 6.965a3.982 3.982 0 0 0-.13.8ZM10 0a1.5 1.5 0 0 1 1.493 1.356l.007.144v.695a5.999 5.999 0 0 1 4.495 5.552L16 8v3.172l-2-2V8c0-2.14-1.687-3.89-3.8-3.995L10 4c-.358 0-.705.047-1.036.136L7.417 2.589c.258-.123.527-.228.803-.314l.28-.08V1.5A1.5 1.5 0 0 1 10 0Z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgIconNotificationsOff;